import { render, staticRenderFns } from "./FloatingVideoPlayer.vue?vue&type=template&id=2f613712&scoped=true"
import script from "./FloatingVideoPlayer.vue?vue&type=script&lang=js"
export * from "./FloatingVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./FloatingVideoPlayer.vue?vue&type=style&index=0&id=2f613712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f613712",
  null
  
)

export default component.exports